import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyConnections = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 224 120",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			opacity: .6,
			filter: "url(#filter0_d_1696_4488)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "path-1-inside-1_1696_4488",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", { d: "M91.9658 16.3934C93.0488 16.1761 94.1029 16.8779 94.3201 17.9609L107.695 84.6325C107.913 85.7155 107.211 86.7696 106.128 86.9869L23.7688 103.509C22.6858 103.726 21.6317 103.025 21.4145 101.942L8.03924 35.2701C7.82198 34.1871 8.52379 33.133 9.60678 32.9157L91.9658 16.3934Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M91.9658 16.3934C93.0488 16.1761 94.1029 16.8779 94.3201 17.9609L107.695 84.6325C107.913 85.7155 107.211 86.7696 106.128 86.9869L23.7688 103.509C22.6858 103.726 21.6317 103.025 21.4145 101.942L8.03924 35.2701C7.82198 34.1871 8.52379 33.133 9.60678 32.9157L91.9658 16.3934Z",
					fill: "var(--token-color-bg-subtle)",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M94.3201 17.9609L93.3397 18.1576L106.715 84.8292L107.695 84.6325L108.676 84.4358L95.3006 17.7642L94.3201 17.9609ZM106.128 86.9869L105.931 86.0064L23.5721 102.529L23.7688 103.509L23.9655 104.49L106.325 87.9673L106.128 86.9869ZM21.4145 101.942L22.3949 101.745L9.01971 35.0734L8.03924 35.2701L7.05878 35.4667L20.434 102.138L21.4145 101.942ZM9.60678 32.9157L9.80348 33.8962L92.1625 17.3739L91.9658 16.3934L91.7691 15.4129L9.41009 31.9353L9.60678 32.9157ZM8.03924 35.2701L9.01971 35.0734C8.91108 34.5319 9.26198 34.0048 9.80348 33.8962L9.60678 32.9157L9.41009 31.9353C7.7856 32.2612 6.73288 33.8423 7.05878 35.4667L8.03924 35.2701ZM23.7688 103.509L23.5721 102.529C23.0306 102.637 22.5036 102.286 22.3949 101.745L21.4145 101.942L20.434 102.138C20.7599 103.763 22.341 104.816 23.9655 104.49L23.7688 103.509ZM107.695 84.6325L106.715 84.8292C106.824 85.3707 106.473 85.8978 105.931 86.0064L106.128 86.9869L106.325 87.9673C107.949 87.6414 109.002 86.0603 108.676 84.4358L107.695 84.6325ZM94.3201 17.9609L95.3006 17.7642C94.9747 16.1397 93.3936 15.087 91.7691 15.4129L91.9658 16.3934L92.1625 17.3739C92.704 17.2652 93.2311 17.6161 93.3397 18.1576L94.3201 17.9609Z",
					fill: "var(--token-color-border)",
					mask: "url(#path-1-inside-1_1696_4488)"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .59,
					clipPath: "url(#clip0_1696_4488)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M50.5868 69.543L49.8121 65.6188L67.4712 62.1323L68.246 66.0566L50.5868 69.543ZM52.3553 68.1746L54.3174 67.7872L53.93 65.8251L51.9679 66.2124L52.3553 68.1746ZM48.2626 57.7703L47.4878 53.846L65.1469 50.3596L65.9217 54.2838L48.2626 57.7703ZM50.031 56.4018L51.9931 56.0144L51.6057 54.0523L49.6436 54.4397L50.031 56.4018ZM49.4247 63.6566L48.6499 59.7324L66.3091 56.2459L67.0838 60.1702L49.4247 63.6566ZM51.1931 62.2882L53.1553 61.9008L52.7679 59.9387L50.8058 60.3261L51.1931 62.2882Z",
						fill: "var(--token-color-accent)"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .6,
			filter: "url(#filter1_d_1696_4488)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "path-4-inside-2_1696_4488",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", { d: "M131.769 16.3934C130.686 16.1761 129.632 16.8779 129.415 17.9609L116.039 84.6325C115.822 85.7155 116.524 86.7696 117.607 86.9869L199.966 103.509C201.049 103.726 202.103 103.025 202.32 101.942L215.696 35.2701C215.913 34.1871 215.211 33.133 214.128 32.9157L131.769 16.3934Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M131.769 16.3934C130.686 16.1761 129.632 16.8779 129.415 17.9609L116.039 84.6325C115.822 85.7155 116.524 86.7696 117.607 86.9869L199.966 103.509C201.049 103.726 202.103 103.025 202.32 101.942L215.696 35.2701C215.913 34.1871 215.211 33.133 214.128 32.9157L131.769 16.3934Z",
					fill: "var(--token-color-bg-subtle)",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M129.415 17.9609L130.395 18.1576L117.02 84.8292L116.039 84.6325L115.059 84.4358L128.434 17.7642L129.415 17.9609ZM117.607 86.9869L117.804 86.0064L200.163 102.529L199.966 103.509L199.769 104.49L117.41 87.9673L117.607 86.9869ZM202.32 101.942L201.34 101.745L214.715 35.0734L215.696 35.2701L216.676 35.4667L203.301 102.138L202.32 101.942ZM214.128 32.9157L213.931 33.8962L131.572 17.3739L131.769 16.3934L131.966 15.4129L214.325 31.9353L214.128 32.9157ZM215.696 35.2701L214.715 35.0734C214.824 34.5319 214.473 34.0048 213.931 33.8962L214.128 32.9157L214.325 31.9353C215.949 32.2612 217.002 33.8423 216.676 35.4667L215.696 35.2701ZM199.966 103.509L200.163 102.529C200.704 102.637 201.231 102.286 201.34 101.745L202.32 101.942L203.301 102.138C202.975 103.763 201.394 104.816 199.769 104.49L199.966 103.509ZM116.039 84.6325L117.02 84.8292C116.911 85.3707 117.262 85.8978 117.804 86.0064L117.607 86.9869L117.41 87.9673C115.786 87.6414 114.733 86.0603 115.059 84.4358L116.039 84.6325ZM129.415 17.9609L128.434 17.7642C128.76 16.1397 130.341 15.087 131.966 15.4129L131.769 16.3934L131.572 17.3739C131.031 17.2652 130.504 17.6161 130.395 18.1576L129.415 17.9609Z",
					fill: "var(--token-color-border)",
					mask: "url(#path-4-inside-2_1696_4488)"
				}),
				/* @__PURE__ */ _jsx("g", {
					opacity: .59,
					clipPath: "url(#clip1_1696_4488)",
					children: /* @__PURE__ */ _jsx("path", {
						d: "M173.148 69.543L173.922 65.6188L156.263 62.1323L155.488 66.0566L173.148 69.543ZM171.379 68.1746L169.417 67.7872L169.804 65.8251L171.766 66.2124L171.379 68.1746ZM175.472 57.7703L176.247 53.846L158.587 50.3596L157.813 54.2838L175.472 57.7703ZM173.703 56.4018L171.741 56.0144L172.129 54.0523L174.091 54.4397L173.703 56.4018ZM174.31 63.6566L175.084 59.7324L157.425 56.2459L156.651 60.1702L174.31 63.6566ZM172.541 62.2882L170.579 61.9008L170.966 59.9387L172.929 60.3261L172.541 62.2882Z",
						fill: "var(--token-color-accent)"
					})
				})
			]
		}),
		/* @__PURE__ */ _jsxs("g", {
			filter: "url(#filter2_d_1696_4488)",
			children: [
				/* @__PURE__ */ _jsx("mask", {
					id: "path-7-inside-3_1696_4488",
					fill: "white",
					children: /* @__PURE__ */ _jsx("path", { d: "M153.646 32C154.751 32 155.646 32.8954 155.646 34V98C155.646 99.1046 154.751 100 153.646 100H69.646C68.5414 100 67.646 99.1046 67.646 98V34C67.646 32.8954 68.5414 32 69.646 32H153.646Z" })
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M153.646 32C154.751 32 155.646 32.8954 155.646 34V98C155.646 99.1046 154.751 100 153.646 100H69.646C68.5414 100 67.646 99.1046 67.646 98V34C67.646 32.8954 68.5414 32 69.646 32H153.646Z",
					fill: "var(--token-color-bg)",
					shapeRendering: "crispEdges"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M155.646 34H154.646V98H155.646H156.646V34H155.646ZM153.646 100V99H69.646V100V101H153.646V100ZM67.646 98H68.646V34H67.646H66.646V98H67.646ZM69.646 32V33H153.646V32V31H69.646V32ZM67.646 34H68.646C68.646 33.4477 69.0937 33 69.646 33V32V31C67.9891 31 66.646 32.3431 66.646 34H67.646ZM69.646 100V99C69.0937 99 68.646 98.5523 68.646 98H67.646H66.646C66.646 99.6569 67.9891 101 69.646 101V100ZM155.646 98H154.646C154.646 98.5523 154.198 99 153.646 99V100V101C155.303 101 156.646 99.6569 156.646 98H155.646ZM155.646 34H156.646C156.646 32.3431 155.303 31 153.646 31V32V33C154.198 33 154.646 33.4477 154.646 34H155.646Z",
					fill: "var(--token-color-border)",
					mask: "url(#path-7-inside-3_1696_4488)"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M102.646 74V70H120.646V74H102.646ZM104.646 73H106.646V71H104.646V73ZM102.646 62V58H120.646V62H102.646ZM104.646 61H106.646V59H104.646V61ZM102.646 68V64H120.646V68H102.646ZM104.646 67H106.646V65H104.646V67Z",
					fill: "var(--token-color-accent)"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_d_1696_4488",
				x: -.354004,
				y: 10,
				width: 116.443,
				height: 103.903,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1696_4488"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1696_4488",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_d_1696_4488",
				x: 107.646,
				y: 10,
				width: 116.443,
				height: 103.903,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1696_4488"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1696_4488",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_d_1696_4488",
				x: 59.646,
				y: 26,
				width: 104,
				height: 84,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
					/* @__PURE__ */ _jsx("feComposite", {
						in2: "hardAlpha",
						operator: "out"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_1696_4488"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect1_dropShadow_1696_4488",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip0_1696_4488",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 24,
					height: 24,
					fill: "white",
					transform: "translate(43.77 50.5028) rotate(-11.1683)"
				})
			}),
			/* @__PURE__ */ _jsx("clipPath", {
				id: "clip1_1696_4488",
				children: /* @__PURE__ */ _jsx("rect", {
					width: 24,
					height: 24,
					fill: "white",
					transform: "matrix(-0.981063 -0.193691 -0.193691 0.981063 179.964 50.5028)"
				})
			})
		] })
	]
});
export default SvgEmptyConnections;
